import { gql } from '@apollo/client'

export default gql(`
    mutation deleteApiKey($id: ID! $project: String) {
        deleteApiKey(
            id: $id
            project: $project
        ) {
            id
        }
    }`
)
